const translations = {
  'hu': require('@/translations/hu.json'),
  'en': require('@/translations/en.json'),
};

const HU_VOWELS = 'aeiouáéíóöőúüűAEIOUÁÉÍÓÖŐÚÜŰ';
const HU_SKIPPED_CHARS = '"\'`„“”‟«»‹›‚‘’()[]{}*_#';

function huNumberNeedsAzArticle(numberStr) {
  const digits = numberStr.replace(/\D/g, '');
  if (!digits) {
    return false;
  }

  const firstDigit = Number(digits[0]);
  const leadingGroupLength = ((digits.length - 1) % 3) + 1;

  return firstDigit === 5 || (firstDigit === 1 && leadingGroupLength === 1);
}

function huNeedsAzArticle(word) {
  let rest = word;
  while (rest.length > 0 && HU_SKIPPED_CHARS.includes(rest[0])) {
    rest = rest.slice(1);
  }

  if (rest.length === 0) {
    return false;
  }

  const number = rest.match(/^\d[\d \u00A0.]*/);
  if (number) {
    return huNumberNeedsAzArticle(number[0]);
  }

  return HU_VOWELS.includes(rest[0]);
}

function replaceParameters(str, params, language) {
  if (!str || typeof str !== 'string') {
    return str;
  }

  str = str.trim();

  if (params) {
    const numericValues = [];

    Object.keys(params).forEach(param => {
      const value = params[param];
      if (language === 'en' && typeof value === 'number') {
        numericValues.push(value);
      }
      str = str.replaceAll(param, value);
    });

    if (language === 'hu') {
      if (str.indexOf('(z) ') !== -1) {
        str = str.replace(/\b([Aa])\(z\) (\S+)/g, (match, a, nextWord) => (
          huNeedsAzArticle(nextWord) ? `${a}z ${nextWord}` : `${a} ${nextWord}`
        ));
      }
    }
    else if (language === 'en' && numericValues.length > 0) {
      // replace (s) only if it is at the end of a word (followed by whitespace, punctuation, or end of string)
      numericValues.forEach(num => {
        const replacement = num === 1 ? '' : 's';
        const numStr = String(num).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        // number followed by 1 or 2 words
        const regex = new RegExp(`\\b${numStr}\\b(\\s+\\S+){1,2}`, 'g');
        str = str.replace(regex, match => match.replace(/\(s\)(?=\W|$)/, replacement));
      });
    }
  }

  return str;
}

export const tr = (str, params, language) => {
  if (!params) {
    params = {};
  }
  params[':app'] = process.env.VUE_APP_NAME ?? 'Infinite∞Ad';

  if (translations[language] && translations[language][str]) {
    return replaceParameters(translations[language][str], params, language);
  }

  if (language !== 'en' && process.env.NODE_ENV !== 'production') {
    // console.warn('Missing "' + str + '" ' + language + ' translation.');
  }

  if (
    translations['en']
    && str in translations['en']
    && translations['en'][str].trim() !== ''
  ) {
    return replaceParameters(translations['en'][str], params, language);
  }

  return replaceParameters(str, params, language);
};

export default {
  methods: {
    tr(str, params) {
      return tr(str, params, this.$root.language);
    },
    translateOptionList(list, labelKey) {
      if (!labelKey) {
        labelKey = 'label';
      }

      const copy = JSON.parse(JSON.stringify(list));
      return copy.map(item => {
        item[labelKey] = this.tr(item[labelKey]);
        return item;
      });
    },
  },
};
